import React from 'react';
import merge from 'classnames';

import { IconWarningV2 } from '../../icons/IconWarningV2';
import { OrderBlockWrapper } from '../../modals/SubmitOrder/components/Common/OrderBlockWrapper';

import { Props } from './types';

import styles from './WarningBanner.module.scss';

export const WarningBanner = ({ title, subTitle, alignment }: Props) => {
  const isHorizontal = alignment === 'horizontal';
  const warningWrapperAlignment = isHorizontal ? styles.warningWrapperHorizontal : '';
  const warningContainerAlignment = isHorizontal ? styles.warningContainerHorizontal : '';
  const warningSubtitle = isHorizontal ? styles.warningSubtitleHorizontal : '';

  return (
    <OrderBlockWrapper color="rgba(0, 46, 93, 0.05)">
      <div
        className={merge(styles.warningContainer, warningContainerAlignment)}
        data-testid="warning-banner-container"
      >
        <IconWarningV2
          classes={{ container: styles.warningIconContainer, icon: styles.warningIconSvg }}
        />
        <div
          className={merge(styles.warningWrapper, warningWrapperAlignment)}
          data-testid="warning-banner-wrapper"
        >
          <div className={styles.warningTitle} data-testid="warning-banner-title">
            {title}
          </div>
          <div
            className={merge(styles.warningSubtitle, warningSubtitle)}
            data-testid="warning-banner-subtitle"
          >
            {subTitle}
          </div>
        </div>
      </div>
    </OrderBlockWrapper>
  );
};
